import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"



import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

    const CustomerComplaints = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [complaints, setComplaints] = useState([])
        const [categories, setCategories] = useState([])
        const [isLoading, setIsLoading] = useState(false)
        const [assigns, setAssigns] = useState([])
        const [deptList, setDeptList] = useState([])
        const [areas, setAreas] = useState([])

        
        const [statusOptions, setStatusOptions] = useState(['Open', 'Assigned', 'Re-Assigned', 'Closed'])

        const [sDate, setSDate]         = useState([new Date()])
        const [eDate, setEDate]         = useState([new Date()])
        const [sArea, setSArea]         = useState('')
        const [sStatus, setSStatus]     = useState('')
        const [sCategory, setSCategory] = useState('')
        const [sRefNo, setSRefNo]       = useState('')
        const [sPhoneNo, setSPhoneNo]   = useState('')
        const [sStaff, setSStaff]       = useState('')
        const [sMine, setSMine]         = useState('')
        const [sDept, setSDept]         = useState('')
        const [sHandler, setSHandler]   = useState('')
        const [userId, setUserId]       = useState('')
        const [userName, setUserName]   = useState('')

       
        const fetchData = () => {
          
          axios.get(url.COMPLAINTCATEGORIES, Config).then((r)=>{ 
            setCategories(r.data)
          }).catch((e)=>{  
            console.log(e)
          });
          axios.get(`${url.USERS}`, Config).then((r)=>{ 
            setAssigns(r.data)
          }).catch((e)=>{  
            console.log(e);
          });
          axios.get(`${url.TERRITORIES}`, Config).then((r)=>{ 
            setAreas(r.data);
          }).catch((e)=>{  
            console.log(e);
          });
          axios.get(url.DEPTS, Config).then((r)=>{ setDeptList(r.data)}).catch((e)=>console.log(e))
          handleFilterData()
        }
        
        useEffect(() => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setSArea(obj.userAreas);
          }
          fetchData() 
        },[]);

        
        const handleCheckAcc = (a) =>{
          const data = {supplyNo: a}
          console.log('Getting coordinates...')
          axios.post(url.GIS, JSON.stringify(data), Config).then((r)=>{ 
            console.log('Got something...')
            if(r.data.status == 'success'){
              console.log('Here they are:')
              //const cods = JSON.parse(r.data.data[0].geo).coordinates
              console.log(r.data.data)
            }
          }).catch((e)=>{ console.log(e); console.log('Failed to get') })
        }
        
        const handleFilterData = () =>{
          const data = {
            refno     : sRefNo,
            phone     : sPhoneNo,
            area      : sArea,
            category  : sCategory,
            status    : sStatus,
            staff     : sStaff,
            mine      : sMine,
            dept      : sDept,
            handler   : sHandler,
            startDate : formatDate(sDate),
            endDate   : formatDate(eDate),
          }
          setIsLoading(true)
          axios.post(`${url.COMPLAINTFILTER}`, JSON.stringify(data), Config).then((r)=>{ 
            setComplaints(r.data)
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        const handleClearSearch = () =>{
          setSRefNo('')
          setSPhoneNo('')
          setSArea('')
          setSCategory('')
          setSStatus('')
          setSStaff('')
          setSDate(new Date())
          setEDate(new Date())
          setSMine('')
          setSDept('')
          setSHandler('')
          handleFilterData()
        }


        const pageOptions = {
          sizePerPage: 10000,
          totalSize: complaints.length, // replace later with size(orders),
          custom: true,
        }
        var node = useRef();
              

        const { SearchBar } = Search;
        const columns = [

        {
          dataField: 'dateTime',
          text: 'Date and Time',
          sort: true
        },
        {
          dataField: 'name',
          text: 'Name',
          sort: true
        },
        {
          dataField: 'refno',
          text: 'Reference',
          sort: true
        }, 

        {
          dataField: 'account',
          text: 'Acc No',
          sort: true
        }, 
        {
          dataField: 'phone',
          text: 'Phone No',
          sort: true
        }, 
        {
          dataField: 'type',
          text: 'Type',
          sort: true
        }, 
        {
          dataField: 'staff',
          text: 'Staff',
          sort: true
        }, 
        {
          dataField: 'status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];

        function noFormatter(cellContent, row){
          return(
            <strong>{cellContent}</strong>
          )
        }
        function actionFormatter(cellContent, row){
          return(
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  //onClick={() => { handleClickDetails(row); }}
                  onClick={()=>{ history.push("Customer-Complaint-Details/"+ be.encryptId(row.id));}}
                >
                  Details
            </Button>
          )
        }
        function statusFormatter(cellContent, row) {
          if (row.status == "Open") {
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }else if((row.status == "Assigned") || (row.status == "Re-Assigned")){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Customer Complaints | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                     
                        <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                    
                                    </Row>
                                </div>
                                
                  
                                

                                                <Row className="justify-content-center mb-1">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Reference No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sRefNo} onChange={(e)=>setSRefNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Phone No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sPhoneNo} onChange={(e)=>setSPhoneNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>From</label>
                                                          <Flatpickr
                                                            className="form-control form-control-sm"
                                                            options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false
                                                            }}
                                                            value={sDate}
                                                            onChange={(dates)=>setSDate(dates)}
                                                            />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Till </label>
                                                          <Flatpickr
                                                              className="form-control form-control-sm"
                                                              options={{
                                                                  dateFormat: "Y-m-d",
                                                                  enableTime: false
                                                              }}
                                                              value={eDate}
                                                              onChange={(dates)=>setEDate(dates)}
                                                              />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                          <option value="">All</option>
                                                              {statusOptions.map((s,k)=>(
                                                                  <option value={s} key={k}>{s}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  </Row>
                                                <Row className="justify-content-center mb-2">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>District</label>
                                                          <select className="form-select form-select-sm" value={sArea} onChange={(e)=>setSArea(e.target.value)}>
                                                          <option value="">All</option>
                                                              {areas.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                
                                                  
                            
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Category</label>
                                                          <select className="form-select form-select-sm" value={sCategory} onChange={(e)=>setSCategory(e.target.value)}>
                                                              <option value="">All</option>
                                                              {categories.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Created by</label>
                                                          <select className="form-select form-select-sm" value={sStaff} onChange={(e)=>setSStaff(e.target.value)}>
                                                              <option value="">All</option>
                                                              {assigns.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Assigned to me</label>
                                                          <select className="form-select form-select-sm" value={sMine} onChange={(e)=>{setSMine(e.target.value)}}>
                                                              <option value={``}>-</option>
                                                              <option value="">List all complaints</option>
                                                              <option value={userId}>List complaints assigned to me</option>
                                                          </select>
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Department</label>
                                                          <select className="form-select form-select-sm" value={sDept} onChange={(e)=>{setSDept(e.target.value)}}>
                                                              <option value={``}>All</option>
                                                              {deptList.map((x,k)=>(
                                                                  <option key={k} value={x.id}>{x.name}</option>
                                                              ))}
                                                          </select>
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Handler</label>
                                                          <select className="form-select form-select-sm" value={sHandler} onChange={(e)=>setSHandler(e.target.value)}>
                                                          <option value={``}>All</option>
                                                          {assigns.map((a,k)=>(
                                                              <option key={k} value={a.id}>{a.name} - {a.deptName}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        //onClick={()=>{handleClickAdd()}}
                                                        onClick={()=>{ history.push("/Register-Complaint")}}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Register complaint
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Customer Complaints ({complaints.length})</h5>
                                                  <CardBody>

                                                  
                                            
                                {(complaints.length > 0) && (

                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="id"
                                    columns={columns}
                                    data={complaints}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ complaints }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  
                                                  keyField='id' 
                                                  data={ complaints } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  style={{ backgroundColor: 'white' }}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                                  </div>
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {complaints && (complaints.length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No Complaint found</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        //onClick={()=>{handleClickAdd()}}
                                        onClick={()=>{ history.push("/Register-Complaint")}}
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Register Complaint <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default CustomerComplaints;